// extracted by mini-css-extract-plugin
module.exports = {"nameAndPhoneList":"ContactInfo_nameAndPhoneList__gUnR5","label":"ContactInfo_label__t74A6","editButton":"ContactInfo_editButton__B34zE"};